export const BreakpointsMap = {
  phxXsMobile: 'xs-mobile',
  phxSmMobile: 'sm-mobile',
  phxSmTablet: 'sm-tablet',
  phxMdTablet: 'md-tablet',
  phxLgDesktop: 'lg-desktop',
  phxXlDesktop: 'xl-desktop',
} as const;